import React from 'react';



export const TableDataIssues = ({}) => {
  return React.createElement('h2', null, "TableDataIssues Component" );
};
